<template>
  <el-dialog
    v-drag
    :visible.sync="dialogVisible"
    width="400px"
    :append-to-body="true"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :show-close="false"
  >
    <div class="error">
      <img src="@/assets/images/bill/warning-1.png" />
    </div>
    <p class="title">是否确定驳回？</p>
    <p class="errorMessage">
      确定驳回，提单状态将退回“预报已发送”，
      并需要重新审核发票
    </p>
    <span slot="footer" class="footers">
      <div class="cancel flex_c_c" @click="cancel">取 消</div>
      <div class="ok flex_c_c" @click="ok">驳回</div>
    </span>
  </el-dialog>
</template>

<script>
import { rejectForecast } from '@/api/bill'
export default {
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    },
    mblId: {
        type: String,
        default: ''
    }
  },
  methods: {
    cancel() {
      this.$emit('cancel')
    },
    async ok() {
      try {
        const res = await rejectForecast({
            mblId: this.mblId
        })
        if (res.success) {
          this.$message.success('驳回成功')
          this.$emit('ok')
        } else {
          this.$message.error(res.errorMessage)
        }
      } catch (error) {
        console.log(error)
      }
    }
  }
}
</script>

<style lang="less" scoped>
:deep(.el-dialog__header) {
  display: none;
}
:deep(.el-dialog__body) {
    padding: 20px 60px;
}
.error {
  margin: 0 auto;
  text-align: center;
}
.title {
  width: 100%;
  height: 20px;
  font-size: 16px;
  font-family: Microsoft YaHei, Microsoft YaHei;
  font-weight: 400;
  color: #fe453d;
  line-height: 20px;
  margin-top: 10px;
  text-align: center;
}
.errorMessage {
  width: 100%;
  font-size: 14px;
  font-family: Microsoft YaHei, Microsoft YaHei;
  font-weight: 400;
  color: #666666;
  line-height: 20px;
  margin-top: 10px;
  text-align: center;
}
.footers {
  width: 100%;
  display: flex;
  justify-content: center;
  .cancel {
    width: 120px;
    height: 40px;
    background: #eeeeee;
    border-radius: 4px 4px 4px 4px;
    font-size: 14px;
    font-family: Microsoft YaHei-Regular, Microsoft YaHei;
    font-weight: 400;
    color: #999999;
    margin-right: 16px;
    cursor: pointer;
  }
  .ok {
    width: 120px;
    height: 40px;
    background:  rgb(18,88,188);
    border-radius: 4px 4px 4px 4px;
    font-size: 14px;
    cursor: pointer;
    font-family: Microsoft YaHei-Regular, Microsoft YaHei;
    font-weight: 400;
    color: #ffffff;
  }
}
</style>
